/**
 * @module views\mdl\structure
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Watch } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { TreeNode } from "element-ui/types/tree";
import StructureNavigation from "@/businessComponents/mdl/structureNavigation/structureNavigation";
import LevelNavigation from "@/businessComponents/mdl/levelNavigation/levelNavigation";

@Component({
  components: {
    StructureNavigation,
    LevelNavigation
  }
})
export default class Structure extends GhBase {
  private argsQuery = { parent_id: "-1" };

  private selectedLevel: TreeNode<string, IndexObject> | null = null;

  private get selectedLevelName() {
    if (this.selectedLevel) {
      return this.selectedLevel.data.Name;
    }
    return "";
  }
  private updateModelLevel(model) {
    if (model && this.selectedLevel) {
      model.LevelId = this.selectedLevel.key;
      model.Level = this.selectedLevel.data.Name;
      model.LevelIcon = this.selectedLevel.data.icon;
      console.log(model);
    }
  }

  private selected = [];

  private tabs: IGhTab[] = [
    { title: "层级模型", drawer: true, show: true },
    { title: "层级模型示例", show: true }
  ];
  private parent: IndexObject = {};

  @Watch("selected")
  private observeSelected() {
    if (this.selected && this.selected.length > 0) {
      this.tabs[1].show = true;
    } else {
      this.tabs[1].show = false;
    }
  }

  @Watch("parent")
  private parentChanged() {
    if (this.parent) {
      this.argsQuery.parent_id = this.parent.key;
      let table = this.$refs.table as GhTablePage;
      let tree = this.$refs.tree as StructureNavigation;
      if (tree) {
        tree.query();
      }
      table.query(this.argsQuery);
    }
  }

  private beforeSave(item: IndexObject) {
    let node = this.parent as TreeNode<string, IndexObject>;
    if (node) {
      let pid = node.key;
      item.ParentId = pid;
    }
  }
}
